import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const dynamicPermissions = _.result(config.get('permissions'), 'dynamic', {});
const { IsRenameHotelToLodgingEnabled, CPSReporting } = dynamicPermissions;

export const i18nFilterTitleMap = {
  AbsoluteTopImpressionRatePercent: _TL_('Absolute top impression rate percent'),
  AbsoluteTopImpressionShareLostToBudgetPercent: _TL_('Absolute top impression share lost to budget percent'),
  AbsoluteTopImpressionShareLostToRankPercent: _TL_('Absolute top impression share lost to rank percent'),
  AbsoluteTopImpressionSharePercent: _TL_('Absolute top impression share percent'),
  AccountId: _TL_('Account ID'),
  AccountName: _TL_('Account name'),
  AccountNumber: _TL_('Account number'),
  AccountStatus: _TL_('Account status'),
  AdDescription: _TL_('Ad description'),
  AdDescription2: _TL_('Ad description 2'),
  AdDistribution: _TL_('Ad distribution'),
  AdExtensionId: _TL_('Ad extension ID'),
  AdExtensionPropertyValue: _TL_('Ad extension property value'),
  AdExtensionType: _TL_('Ad extension type'),
  AdExtensionTypeId: _TL_('Ad extension type ID'),
  AdExtensionVersion: _TL_('Ad extension version'),
  AdGroupCriterionId: _TL_('Ad group criterion ID'),
  AdGroupId: _TL_('Ad group ID'),
  AdGroupLabels: _TL_('Ad group labels'),
  AdGroupName: _TL_('Ad group name'),
  AdGroupStatus: _TL_('Ad group status'),
  AdGroupTypePreview: _TL_('Ad group type'),
  AdGroupType: _TL_('Ad group type'),
  AdId: _TL_('Ad ID'),
  AdjustmentAmount: _TL_('Adjustment amount'),
  AdjustmentCouponAmount: _TL_('Adjustment coupon amount'),
  AdLabels: _TL_('Ad labels'),
  AdRelevance: _TL_('Ad relevance'),
  AdRelevanceCampaign: _TL_('Ad relevance (campaign)'),
  AdRelevanceAdGroup: _TL_('Ad relevance (Ad Group)'),
  AdRelevanceKeyword: _TL_('Ad relevance (Keyword)'),
  AdScenarioType: _TL_('Ad scenario type'),
  AdStatus: _TL_('Ad status'),
  AdStrength: _TL_('Ad strength'),
  AdStrengthActionItems: _TL_('Ad strength action items'),
  AdTitle: _TL_('Ad title'),
  AdType: _TL_('Ad type'),
  AdvancedBookingWindow: _TL_('Advanced booking window'),
  AdvertiserHotelId: IsRenameHotelToLodgingEnabled ? _TL_('Advertiser property ID') : _TL_('Advertiser hotel ID'),
  AgencyName: _TL_('Agency name'),
  AgeGroup: _TL_('Age group'),
  AllConversionRate: _TL_('All conversion rate'),
  AllConversionRateQualified: _TL_('All conversion rate'),
  AllConversions: _TL_('All conversions'),
  AllConversionsQualified: _TL_('All conversions'),
  AllCostPerConversion: _TL_('All CPA'),
  AllCostPerConversionQualified: _TL_('All CPA'),
  AllReturnOnAdSpend: _TL_('All return on ad spend'),
  AllRevenue: _TL_('All revenue'),
  AllRevenuePerConversion: _TL_('All revenue per conversion'),
  AreaCode: _TL_('Area code'),
  AssistedClicks: _TL_('Assisted clicks'),
  AssistedConversions: _TL_('Assisted conversions'),
  AssistedImpressions: _TL_('Assisted impressions'),
  Assists: _TL_('Assists'),
  AssociationId: _TL_('Association ID'),
  AssociationLevel: _TL_('Association level'),
  AssociationStatus: _TL_('Association status'),
  AttributeChanged: _TL_('Attribute changed'),
  AudienceId: _TL_('Audience ID'),
  AudienceImpressionLostToBudgetPercent: _TL_('Audience impression lost to budget percent'),
  AudienceImpressionLostToRankPercent: _TL_('Audience impression lost to rank percent'),
  AudienceImpressionSharePercent: _TL_('Audience impression share percent'),
  AudienceName: _TL_('Audience name'),
  AudienceType: _TL_('Audience type'),
  AverageCPC: _TL_('Average CPC'),
  AverageCPM: _TL_('Average CPM'),
  AverageCPV: _TL_('Average CPV'),
  AverageCpp: _TL_('Average CPP'),
  AveragePosition: _TL_('Average position'),
  AverageWatchTimePerImpression: _TL_('Average watch time per impression'),
  AverageWatchTimePerVideoView: _TL_('Average watch time per video view'),
  AvgBookedABW: _TL_('Average booked ABW'),
  AvgBookedNights: _TL_('Average booked nights'),
  BaseCampaignId: _TL_('Base campaign ID'),
  BDAmount: _TL_('BD amount'),
  BenchmarkBid: _TL_('Benchmark bid'),
  BenchmarkBidProduct: _TL_('Benchmark bid (product)'),
  BenchmarkCtr: _TL_('Benchmark CTR'),
  BenchmarkCtrProduct: _TL_('Benchmark CTR (product)'),
  BidAdjustment: _TL_('Bid adjustment'),
  BidMatchType: _TL_('Bid match types'),
  BidStrategyType: _TL_('Bid strategy type'),
  BilledAmount: _TL_('Billed amount'),
  BilledAmountUSD: _TL_('Billed amount USD'),
  BillingDocumentNumber: _TL_('Billing document'),
  BillingType: _TL_('Billing type'),
  BillToCountry: _TL_('Bill to country'),
  BillToCustomerNumber: _TL_('Bill to customer number'),
  BillToCustomerName: _TL_('Bill to customer name'),
  BookedABW: _TL_('Booked ABW'),
  BookedLengthOfStay: _TL_('Booked length of stay'),
  Brand: _TL_('Brand'),
  BudgetAssociationStatus: _TL_('Budget association status'),
  BudgetChangedAmount: _TL_('Budget changed amount'),
  BudgetChangeOldValue: _TL_('Budget change old value'),
  BudgetChangeNewValue: _TL_('Budget change new value'),
  BudgetName: _TL_('Budget name'),
  BudgetStatus: _TL_('Budget status'),
  BusinessName: _TL_('Business name'),
  CTR: _TL_('CTR'),
  CampaignHotelId: IsRenameHotelToLodgingEnabled ? _TL_('Campaign property ID') : _TL_('Campaign hotel ID'),
  CampaignId: _TL_('Campaign ID'),
  CampaignLabels: _TL_('Campaign labels'),
  CampaignName: _TL_('Campaign name'),
  CampaignStatus: _TL_('Campaign status'),
  CampaignType: _TL_('Campaign type'),
  Category: _TL_('Category'),
  Category0: _TL_('Category 0'),
  Category1: _TL_('Category 1'),
  Category2: _TL_('Category 2'),
  CategoryList: _TL_('Category list'),
  ChangeAmount: _TL_('Amount'),
  ChangeMadeBy: _TL_('Change made by'),
  ChangeMadeTo: _TL_('Change made to'),
  ChangeTotalCount: _TL_('Change total count'),
  ChangeType: _TL_('Change type'),
  ChangedBy: _TL_('Changed by'),
  CheckInDate: _TL_('Check in date'),
  CheckInDateDayOfWeek: _TL_('Check in day of week'),
  City: _TL_('City'),
  ClickCalls: _TL_('Click calls'),
  ClickSharePercent: _TL_('Click share percent'),
  ClickType: _TL_('Click type'),
  ClickTypeId: _TL_('Click type ID'),
  Clicks: _TL_('Clicks'),
  CompanyName: _TL_('Company name'),
  CompletedVideoViews: _TL_('Completed video views'),
  Condition: _TL_('Condition'),
  ConflictLevel: _TL_('Conflict level'),
  ConflictType: _TL_('Conflict type'),
  ConversionRate: _TL_('Conversion rate'),
  ConversionRateQualified: _TL_('Conversion rate'),
  Conversions: _TL_('Conversions'),
  ConversionsQualified: _TL_('Conversions'),
  CostPerAssist: _TL_('Cost per assist'),
  CostPerConversion: _TL_('CPA'),
  CostPerConversionQualified: _TL_('CPA'),
  CountryCode: _TL_('Countries/regions'),
  CountryOfSale: _TL_('Country of sale'),
  FeedLabel: _TL_('Feed label'),
  CountryName: _TL_('Country name'),
  County: _TL_('County'),
  CurrencyCode: _TL_('Currency code'),
  CurrentMaxCpc: _TL_('Current max CPC'),
  CustomLabel0: _TL_('Custom label 0'),
  CustomLabel1: _TL_('Custom label 1'),
  CustomLabel2: _TL_('Custom label 2'),
  CustomLabel3: _TL_('Custom label 3'),
  CustomLabel4: _TL_('Custom label 4'),
  CustomLabel0Product: _TL_('Custom label 0(Product)'),
  CustomLabel1Product: _TL_('Custom label 1(Product)'),
  CustomLabel2Product: _TL_('Custom label 2(Product)'),
  CustomLabel3Product: _TL_('Custom label 3(Product)'),
  CustomLabel4Product: _TL_('Custom label 4(Product)'),
  CustomParameters: _TL_('Custom parameters'),
  CustomParametersCampaign: _TL_('Custom parameters(Campaign)'),
  CustomParametersAdGroup: _TL_('Custom parameters(Ad Group)'),
  CustomParametersKeyword: _TL_('Custom parameters(Keyword)'),
  CustomParametersAd: _TL_('Custom parameters(Ad)'),
  CustomParametersProduct: _TL_('Custom parameters(Product)'),
  CustomerId: _TL_('Customer ID'),
  CustomerName: _TL_('Customer name'),
  DailySpend: _TL_('Daily spend'),
  Date: _TL_('Date'),
  DateTime: _TL_('Date time'),
  DateType: _TL_('Date type'),
  DayOfWeek: _TL_('Day of week'),
  DeliveredMatchType: _TL_('Delivered match types'),
  Description: _TL_('Description'),
  DestinationUrl: _TL_('Destination URL'),
  DestinationUrlAd: _TL_('Destination URL(Ad)'),
  DestinationUrlKeyword: _TL_('Destination URL(Keyword)'),
  DestinationUrlProduct: _TL_('Destination URL(Product)'),
  DeviceOS: _TL_('Device OS'),
  DeviceType: _TL_('Device type'),
  DisplayUrl: _TL_('Display URL'),
  DocumentNumber: _TL_('Document number'),
  DocumentType: _TL_('Document type'),
  Duration: _TL_('Duration'),
  DynamicAdTarget: _TL_('Dynamic ad target'),
  DynamicAdTargetId: _TL_('Dynamic ad target ID'),
  DynamicAdTargetStatus: _TL_('Auto target status'),
  EligibleImpressions: _TL_('Eligible impressions'),
  EndTime: _TL_('End time'),
  EntityId: _TL_('Entity ID'),
  EntityName: _TL_('Entity name'),
  ExactMatchImpressionSharePercent: _TL_('Exact match impression share percent'),
  ExpectedCtr: _TL_('Expected click-through rate'),
  ExpectedCtrKeyword: _TL_('Expected click-through rate(Keyword)'),
  ExpectedCtrCampaign: _TL_('Expected click-through rate(Campaign)'),
  ExpectedCtrAdGroup: _TL_('Expected click-through rate(Ad Group)'),
  ExtendedCost: _TL_('Extended cost'),
  FeedUrl: _TL_('Feed URL'),
  FinalAppUrl: _TL_('Final app URL'),
  FinalMobileUrl: _TL_('Final mobile URL'),
  FinalUrl: _TL_('Final URL'),
  FinalUrlSuffix: _TL_('Final URL suffix'),
  FinalUrlSuffixCampaign: _TL_('Final URL suffix(Campaign)'),
  FinalUrlSuffixAdGroup: _TL_('Final URL suffix(Ad Group)'),
  FinalUrlSuffixKeyword: _TL_('Final URL suffix(Keyword)'),
  FinalUrlSuffixAd: _TL_('Final URL suffix(Ad)'),
  FirstPageBid: _TL_('First page bid'),
  GTIN: _TL_('GTIN'),
  Gender: _TL_('Gender'),
  Goal: _TL_('Goal'),
  GoalCategory: _TL_('Goal category'),
  GoalIds: _TL_('Goal ID'),
  GoalType: _TL_('Goal type'),
  GregorianDate: _TL_('Gregorian date'),
  GrossReturnOnAdSpend: _TL_('Gross return on ad spend'),
  Genre: _TL_('Genre'),
  Headline: _TL_('Headline'),
  HistoricalAdRelevance: _TL_('Historical ad relevance'),
  HistoricalAdRelevanceAdGroup: _TL_('Historical ad relevance(Ad Group)'),
  HistoricalAdRelevanceCampaign: _TL_('Historical ad relevance(Campaign)'),
  HistoricalAdRelevanceKeyword: _TL_('Historical ad relevance(Keyword)'),
  HistoricalExpectedCtr: _TL_('Historical expected CTR'),
  HistoricalExpectedCtrAdGroup: _TL_('Historical expected CTR(Ad Group)'),
  HistoricalExpectedCtrCampaign: _TL_('Historical expected CTR(Campaign)'),
  HistoricalExpectedCtrKeyword: _TL_('Historical expected CTR(Keyword)'),
  HistoricalLandingPageExperience: _TL_('Historical landing page experience'),
  HistoricalLandingPageExperienceAdGroup: _TL_('Historical landing page experience(Ad Group)'),
  HistoricalLandingPageExperienceCampaign: _TL_('Historical landing page experience(Campaign)'),
  HistoricalLandingPageExperienceKeyword: _TL_('Historical landing page experience(Keyword)'),
  HistoricalQualityScore: _TL_('Historical quality score'),
  HistoricalQualityScoreAdGroup: _TL_('Historical quality score(Ad Group)'),
  HistoricalQualityScoreCampaign: _TL_('Historical quality score(Campaign)'),
  HistoricalQualityScoreKeyword: _TL_('Historical quality score(Keyword)'),
  HotelGroup: IsRenameHotelToLodgingEnabled ? _TL_('Property group') : _TL_('Hotel group'),
  HotelGroupNodeId: IsRenameHotelToLodgingEnabled ? _TL_('Property group node ID') : _TL_('Hotel group node ID'),
  HotelName: IsRenameHotelToLodgingEnabled ? _TL_('Property name') : _TL_('Hotel name'),
  HourOfDay: _TL_('Hour of day'),
  Hourly: _TL_('Hourly'),
  HowChanged: _TL_('How changed'),
  ImpressionLostToAdRelevancePercent: _TL_('Impression lost to ad relevance percent'),
  ImpressionLostToBidPercent: _TL_('Impression lost to bid percent'),
  ImpressionLostToBudgetPercent: _TL_('Impression lost to budget percent'),
  ImpressionLostToExpectedCtrPercent: _TL_('Impression lost to expected CTR percent'),
  ImpressionLostToRankAggPercent: _TL_('Impression lost to rank agg percent'),
  ImpressionLostToRankPercent: _TL_('Impression lost to rank percent'),
  ImpressionShare: _TL_('Impression share'),
  ImpressionSharePercent: _TL_('Impression share percent'),
  Impressions: _TL_('Impressions'),
  IndustryName: _TL_('Industry name'),
  InsertionOrderDetails: _TL_('IO details'),
  InsertionOrderId: _TL_('Insertion order ID'),
  IOReportMonth: _TL_('Month'),
  ItemChanged: _TL_('Entity type'),
  JobFunctionName: _TL_('Job function name'),
  KeywordId: _TL_('Keyword ID'),
  KeywordLabels: _TL_('Keyword labels'),
  KeywordStatus: _TL_('Keyword status'),
  Keywords: _TL_('Keywords'),
  LabelName: _TL_('Label'),
  LabelNameAccount: _TL_('Label(Account)'),
  LabelNameCampaign: _TL_('Label(Campaign)'),
  LabelNameAdGroup: _TL_('Label(Ad Group)'),
  LabelNameAd: _TL_('Label(Ad)'),
  LabelNameKeyword: _TL_('Label(Keyword)'),
  LabelColor: _TL_('Label color'),
  LandingPageExperience: _TL_('Landing page experience'),
  LandingPageExperienceAdGroup: _TL_('Landing page experience(Ad Group)'),
  LandingPageExperienceCampaign: _TL_('Landing page experience(Campaign)'),
  LandingPageExperienceKeyword: _TL_('Landing page experience(Keyword)'),
  LandingPageTitle: _TL_('Landing page title'),
  LanguageCode: _TL_('Language'),
  LengthOfStay: _TL_('Length of stay'),
  LocalStoreCode: _TL_('Local store code'),
  LocationId: _TL_('Location ID'),
  LocationType: _TL_('Location type'),
  LongHeadline: _TL_('Long headline'),
  LowQualityClicks: _TL_('Low-quality clicks (not charged)'),
  LowQualityClicksPercent: _TL_('Low-quality clicks percent'),
  LowQualityConversionRate: _TL_('Low-quality click conversion rate'),
  LowQualityConversions: _TL_('Low-quality click conversions'),
  LowQualityConversionsQualified: _TL_('Low-quality click conversions'),
  LowQualityGeneralClicks: _TL_('Low-quality clicks - general (not charged)'),
  LowQualityImpressions: _TL_('Low-quality impressions'),
  LowQualityImpressionsPercent: _TL_('Low-quality impressions percent'),
  LowQualitySophisticatedClicks: _TL_('Low-quality clicks - sophisticated (not charged)'),
  MPN: _TL_('MPN'),
  Mainline1Bid: _TL_('Mainline 1 bid'),
  MainlineBid: _TL_('Mainline bid'),
  ManualCalls: _TL_('Manual calls'),
  MatchedProductsAtAdGroup: _TL_('Matched products at ad group/asset group'),
  MatchedProductsAtCampaign: _TL_('Matched products at campaign'),
  MatchedProductsAtProductGroup: _TL_('Matched products at product group/listing group'),
  MerchantProductId: _TL_('Merchant product ID'),
  MetroArea: _TL_('Metro area'),
  MismatchedAmount: _TL_('Mismatched amount'),
  MismatchedReason: _TL_('Mismatched reason'),
  MissedImpressions: _TL_('Missed impressions'),
  MissedImpressionsNoBid: _TL_('Missed impressions no bid'),
  MissedImpressionsInsufficientBid: _TL_('Missed impressions insufficient bid'),
  MissedImpressionsSpendingCapReached: _TL_('Missed impressions spending cap reached'),
  MissedImpressionsNoTax: _TL_('Missed impressions no tax'),
  MissedImpressionsOther: _TL_('Missed impressions other'),
  Month: _TL_('Month'),
  MonthlyBudget: _TL_('Monthly budget'),
  MonthToDateSpend: _TL_('Month to date spend'),
  MostSpecificLocation: _TL_('Most specific location'),
  NegativeKeyword: _TL_('Negative keyword'),
  NegativeKeywordId: _TL_('Negative keyword ID'),
  NegativeKeywordList: _TL_('Negative keyword list'),
  NegativeKeywordListId: _TL_('Negative keyword list ID'),
  NegativeKeywordMatchType: _TL_('Negative keyword match type'),
  Neighborhood: _TL_('Neighborhood'),
  NetReturnOnAdSpend: _TL_('Net return on ad spend'),
  NetRevenue: _TL_('Net revenue'),
  NetRevenueUSD: _TL_('Net revenue USD'),
  NetAmountDue: _TL_('Net amount Due'),
  Network: _TL_('Network'),
  NewValue: _TL_('New value'),
  OfferLanguage: _TL_('Offer language'),
  OldValue: _TL_('Old value'),
  Param1: _TL_('Param 1'),
  Param2: _TL_('Param 2'),
  Param3: _TL_('Param 3'),
  PartitionType: _TL_('Partition type'),
  PartnerImpressions: _TL_('Partner impressions'),
  Path1: _TL_('Path 1'),
  Path2: _TL_('Path 2'),
  PhoneCalls: _TL_('Phone calls'),
  PhoneImpressions: _TL_('Phone impressions'),
  PlacementName: _TL_('Placement name'),
  PostalCode: _TL_('Postal code'),
  Price: _TL_('Price'),
  PricingMethod: _TL_('Pricing method'),
  ProductBought: _TL_('Product bought'),
  ProductBoughtTitle: _TL_('Product bought title'),
  ProductCategory1: _TL_('Product category 1'),
  ProductCategory2: _TL_('Product category 2'),
  ProductCategory3: _TL_('Product category 3'),
  ProductCategory4: _TL_('Product category 4'),
  ProductCategory5: _TL_('Product category 5'),
  ProductGroup: _TL_('Product group/Listing group'),
  ProductName: _TL_('Product name'),
  ProductType1: _TL_('Product type 1'),
  ProductType2: _TL_('Product type 2'),
  ProductType3: _TL_('Product type 3'),
  ProductType4: _TL_('Product type 4'),
  ProductType5: _TL_('Product type 5'),
  ProximityTargetLocation: _TL_('Proximity target location'),
  Ptr: _TL_('PTR'),
  PublisherUrl: _TL_('Publisher URL'),
  QualityImpact: _TL_('Quality impact'),
  QualityScore: _TL_('Quality score'),
  QualityScoreAdGroup: _TL_('Quality score(Ad Group)'),
  QualityScoreCampaign: _TL_('Quality score(Campaign)'),
  QualityScoreKeyword: _TL_('Quality score(Keyword)'),
  QuantityBought: _TL_('Quantity bought'),
  Quarter: _TL_('Quarter'),
  QueryIntentCity: _TL_('Query intent city'),
  QueryIntentCountry: _TL_('Query intent country'),
  QueryIntentCounty: _TL_('Query intent county'),
  QueryIntentDMA: _TL_('Query intent DMA'),
  QueryIntentLocationId: _TL_('Query intent location ID'),
  QueryIntentNeighborhood: _TL_('Query intent neighborhood'),
  QueryIntentPostalCode: _TL_('Query intent postal code'),
  QueryIntentState: _TL_('Query intent state'),
  Radius: _TL_('Radius'),
  RelativeCTR: _TL_('Relative CTR'),
  RemainingIOBudget: _TL_('Remaining IO budget'),
  ReturnOnAdSpend: _TL_('Return on ad spend'),
  ReturnOnAdSpendCPS: _TL_('Return on ad spend (CPS)'),
  Revenue: _TL_('Revenue'),
  RevenueCPS: _TL_('Revenue (CPS)'),
  RevenuePerAssist: _TL_('Revenue per assist'),
  RevenuePerConversion: _TL_('Revenue per conversion'),
  SalesHouse: _TL_('Sales house'),
  SearchQueries: _TL_('Search term'),
  SellerName: _TL_('Seller name'),
  SoldToCountry: _TL_('Sold to country'),
  SoldToCustomerName: _TL_('Sold to customer name'),
  SoldToCustomerNumber: _TL_('Sold to customer number'),
  SourceHotelId: IsRenameHotelToLodgingEnabled ? _TL_('Source property ID') : _TL_('Source hotel ID'),
  Spend: _TL_('Spend'),
  SpendAmount: _TL_('Spend amount'),
  SpendCouponAmount: _TL_('Spend coupon amount'),
  StarRating: _TL_('Star rating'),
  StartTime: _TL_('Start time'),
  State: _TL_('State'),
  Status: _TL_('Ad group status'),
  StoreId: _TL_('Store ID'),
  TargetingSetting: _TL_('Targeting setting'),
  TimePeriod: _TL_('Time period'),
  Title: _TL_('Title'),
  TitlePart1: _TL_('Title part 1'),
  TitlePart2: _TL_('Title part 2'),
  TitlePart3: _TL_('Title part 3'),
  Tool: _TL_('Tool'),
  TopImpressionRatePercent: _TL_('Top impression rate percent'),
  TopImpressionShareLostToBudgetPercent: _TL_('Top impression share lost to budget percent'),
  TopImpressionShareLostToRankPercent: _TL_('Top impression share lost to rank percent'),
  TopImpressionSharePercent: _TL_('Top impression share percent'),
  TopVsOther: _TL_('Top vs other'),
  TotalClicks: _TL_('Total clicks'),
  TotalClicksOnAdElements: _TL_('Total clicks on ad elements'),
  TotalWatchTimeInMS: _TL_('Total watch time in MS'),
  TrackingTemplate: _TL_('Tracking template'),
  TrackingTemplateCampaign: _TL_('Tracking template(Campaign)'),
  TrackingTemplateAdGroup: _TL_('Tracking template(Ad Group)'),
  TrackingTemplateKeyword: _TL_('Tracking template(Keyword)'),
  TrackingTemplateAd: _TL_('Tracking template(Ad)'),
  TrackingTemplateProduct: _TL_('Tracking template(Product)'),
  UserId: _TL_('User ID'),
  VideoCompletionRate: _TL_('Video completion rate'),
  VideoViews: _TL_('Video views'),
  VideoViewsAt25Percent: _TL_('Video views at 25 percent'),
  VideoViewsAt50Percent: _TL_('Video views at 50 percent'),
  VideoViewsAt75Percent: _TL_('Video views at 75 percent'),
  ViewThroughConversionRate: _TL_('View-through conversion rate'),
  ViewThroughConversionRateQualified: _TL_('View-through conversion rate'),
  ViewThroughConversions: _TL_('View-through conversions'),
  ViewThroughCostPerConversion: _TL_('View-through conv. CPA'),
  ViewThroughCostPerConversionQualified: _TL_('View-through conv. CPA'),
  ViewThroughRate: _TL_('View through rate'),
  ViewThroughReturnOnAdSpend: _TL_('View through return on ad spend'),
  ViewThroughRevenue: _TL_('View through revenue'),
  WebsiteCoverage: _TL_('Website coverage'),
  Week: _TL_('Week'),
  WeekStartingMonday: _TL_('Week starting monday'),
  Year: _TL_('Year'),
  OrderId: _TL_('Order Id'),
  FeedId: _TL_('Feed Id'),
  FeedItemId: _TL_('Feed Item Id'),
  IncrementalBudgetAmount: _TL_('Incremental budget amount'),
  DailyBudgetAmount: _TL_('Daily budget amount'),
  BudgetId: _TL_('Budget ID'),
  ChangeInAdvertiserReportedRevenuePct: _TL_('% Change in All conv. revenue'),
  ChangeInAllConvRatePct: _TL_('% Change in All conv. rate'),
  ChangeInConversionCreditPct: _TL_('% Change in All conv.'),
  ChangeInCPAPct: _TL_('% Change in CPA'),
  ChangeInFullViewAdvertiserReportedRevenuePct: _TL_('% Change in View-through conv. revenue'),
  ChangeInFullViewThroughConversionPct: _TL_('% Change in View-through conv.'),
  ChangeInROASPct: _TL_('% Change in Return on ad spend'),
  ChangeInViewThroughRatePct: _TL_('% Change in View-through conv. rate'),
  ChangeInVTCCPAPct: _TL_('% Change in View-through conv. CPA'),
  ChangeInVTCROASPct: _TL_('% Change in View-through conv. return on ad spend'),
  DDAAllConvRate: _TL_('All conv. rate (DDA'),
  DDACPA: _TL_('CPA (DDA)'),
  DDAFullAdvertiserReportedRevenue: _TL_('All conv. revenue (DDA)'),
  DDAFullConversionCredit: _TL_('All conv. (DDA)'),
  DDAFullViewAdvertiserReportedRevenue: _TL_('View-through conv. revenue (DDA)'),
  DDAFullViewThroughConversion: _TL_('View-through conv. (DDA)'),
  DDAROAS: _TL_('Return on ad spend (DDA)'),
  DDAViewThroughRate: _TL_('View-through conv. rate (DDA)'),
  DDAVTCCPA: _TL_('View-through conv. CPA (DDA)'),
  DDAVTCROAS: _TL_('View through conv. return on ad spend (DDA)'),
  LCAAllConvRate: _TL_('All conv. rate (LCA)'),
  LCACPA: _TL_('CPA (LCA)'),
  LCAFullAdvertiserReportedRevenue: _TL_('All conv. revenue (LCA)'),
  LCAFullConversionCredit: _TL_('All conv. (LCA)'),
  LCAFullViewAdvertiserReportedRevenue: _TL_('View-through conv. revenue (LCA)'),
  LCAFullViewThroughConversion: _TL_('View-through conv. (LCA)'),
  LCAROAS: _TL_('Return on ad spend (LCA)'),
  LCAViewThroughRate: _TL_('View-through conv. rate (LCA)'),
  LCAVTCCPA: _TL_('View-through conv. CPA (LCA)'),
  LCAVTCROAS: _TL_('View-through conv. return on ad spend (LCA)'),
  IsMainConversionGoal: _TL_('Include in converions'),
  Sales: CPSReporting ? _TL_('Sales count') : _TL_('Sales'),
  CostPerSale: CPSReporting ? _TL_('Avg. CPS') : _TL_('Cost per sale'),
  RevenuePerSale: _TL_('Revenue per sale'),
  msxAdClicks: _TL_('Clicks'),
  msxDeliveredCountry: _TL_('Delivered country'),
  msxDeliveredMarket: _TL_('Delivered market'),
  msxDevice: _TL_('Device'),
  msxPageType: _TL_('Page type'),
  msxPlacementId: _TL_('PlacementId'),
  msxProvider: _TL_('Provider'),
  msxPublisher: _TL_('Publisher'),
  msxRegion: _TL_('Region'),
  msxServedImpressions: _TL_('Served impressions'),
  msxServedRevenue: _TL_('Served revenue'),
  msxViewedImpressions: _TL_('Viewed impressions'),
  Installs: _TL_('Installs-legacy'),
  CostPerInstall: _TL_('Cost per install-legacy'),
  RevenuePerInstall: _TL_('Revenue per install-legacy'),
  AssetGroupId: _TL_('Asset group ID'),
  AssetGroupName: _TL_('Asset group'),
  AssetGroupStatus: _TL_('Asset group status'),
  AssetId: _TL_('Asset ID'),
  AssetContent: _TL_('Asset content'),
  AssetType: _TL_('Asset type'),
  AssetSource: _TL_('Asset source'),
  UserCountry: _TL_('User country'),
  SiteType: _TL_('Site type'),
  ClickShare: _TL_('Click share'),
  RevenueAdjustment: _TL_('Revenue adj.'),
  AllRevenueAdjustment: _TL_('All revenue adj.'),
  ViewThroughRevenueAdjustment: _TL_('View-through revenue adj.'),
  VideoStarts: _TL_('Video starts'),
  VideoSkips: _TL_('Video skips'),
  CPCV: _TL_('CPCV'),
  CollectionId: _TL_('Collection ID'),
  AverageImpressionFrequencyPerUser: _TL_('Avg. Impression Frequency per User'),
  AverageImpressionFrequencyPerUser7Day: _TL_('Avg. Impression Frequency per User (7 days)'),
  Reach: _TL_('Unique Reach'),
  Downloads: _TL_('Downloads'),
  PostClickDownloadRate: _TL_('Post-click download rate'),
  CostPerDownload: _TL_('Cost per Download'),
  AppInstalls: _TL_('Install'),
  PostClickInstallRate: _TL_('Post-click install rate'),
  CPI: _TL_('CPI'),
  Purchases: _TL_('In-app purchases'),
  PostInstallPurchaseRate: _TL_('Post-install purchase rate'),
  CPP: _TL_('Cost per in-app purchase'),
  Subscriptions: _TL_('In-app subscriptions'),
  PostInstallSubscriptionRate: _TL_('Post-install subscription rate'),
  CPS: _TL_('Cost per in-app subscription'),
  RevenuePerDownload: _TL_('Revenue per Download'),
  RevenuePerAppInstall: _TL_('Revenue per Install'),
  SearchCategory: _TL_('Search category'),
  SearchVolume: _TL_('Search volume'),
  L1Vertical: _TL_('L1 vertical'),
  L2Vertical: _TL_('L2 vertical'),
  L3Vertical: _TL_('L3 vertical'),
  Country: _TL_('Country'),
  SearchesIndexed: _TL_('Searches'),
  ClicksIndexed: _TL_('Clicks'),
  WoWSearches: _TL_('Week over week (WoW) searches '),
  WoWClicks: _TL_('Week over week (WoW) clicks'),
  MoMSearches: _TL_('Month over month (MoM) searches'),
  MoMClicks: _TL_('Month over month (MoM) clicks'),
  YoYLast1WeekSearches: _TL_('Year over year (YoY) current week searches'),
  YoYLast1WeekClicks: _TL_('Year over year (YoY) current week clicks'),
  YoYLast4WeeksSearches: _TL_('Year over year (YoY) last four week searches'),
  YoYLast4WeeksClicks: _TL_('Year over year (YoY) last four week clicks'),
  SearchesPeekWeek: _TL_('Peak searches (week)'),
  ClicksPeekWeek: _TL_('Peak clicks (week)'),
  MarketplaceClickCoverage: _TL_('Marketplace click coverage'),
  ProportionOfSpend: _TL_('Proportion Of Spend'),
  Headline1: _TL_('Headline1'),
  Headline2: _TL_('Headline2'),
  Headline3: _TL_('Headline3'),
  Description1: _TL_('Description1'),
  Description2: _TL_('Description2'),
  Image: _TL_('Image'),
  Logo: _TL_('Logo'),
  CombinationLongHeadline: _TL_('Long headline'),
  NewCustomerConversions: _TL_('New customer conversions'),
  NewCustomerRevenue: _TL_('New customer revenue'),
  NewCustomerConversionRate: _TL_('New customer conversion rate'),
  NewCustomerCPA: _TL_('New customer CPA'),
  NewCustomerReturnOnAdSpend: _TL_('New customer return on ad spend'),
};
